import { IGeofence } from '../../ModelClassInterfaces'
import { CommonBusinessObject } from '../../types'
import { UserAttributeDefs } from '../../types/ModelTypes'
import { GeoModelCommon } from '../Geo'

const typeName = 'Place'

interface IPlace {
  color?: string | undefined
  icon?: any
}

class Place extends GeoModelCommon implements IPlace {
  color: string | undefined
  icon: any

  constructor(ob: IPlace & CommonBusinessObject & Partial<IGeofence>) {
    super({ ...ob, type: ob.type ?? typeName })
    this.color = ob.color
    this.icon = ob.icon
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'identification',
        validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
      },
    }
  }
}

export { Place }
